angular.module('aprima-provider-api').factory('PersonRepository', [
    'AprimaAnalytics',
    'AprimaRestangular',
    function (
        AprimaAnalytics,
        AprimaRestangular
    ) {
        'use strict';

        return {
            updatePersonPhoto: updatePersonPhoto,
        };

        function updatePersonPhoto(patientId, patientPhoto, applicationComponent) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'PersonRepository', 'api', 'updatePersonPhoto');

            return AprimaRestangular.get()
                .one('persons', patientId)
                .one('photo')
                .customPUT(patientPhoto)
                .finally(timing.stop);
        }
    }
]);
